import PageHero from "@/components/PageHero";
import CTASection from "@/sections/CTASection";
import { INDUSTRIES } from "@/data/industries";
import { motion } from "framer-motion";

const HERO_IMG = "https://images.unsplash.com/photo-1464440579920-df688e377d3c?q=85&w=2400";

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <PageHero
        overline="Industries served"
        title={<>The sectors<br /><span className="italic font-light text-gold">we shape.</span></>}
        subtitle="Government, hospitality, retail, healthcare, education, sport and culture — the breadth of our mandate reflects two decades of multidisciplinary practice."
        image={HERO_IMG}
        breadcrumbs={[{ label: "Industries" }]}
      />

      <section className="bg-white py-24 sm:py-32">
        <div className="container-x">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {INDUSTRIES.map((ind, i) => {
              const Icon = ind.icon;
              return (
                <motion.div
                  key={ind.title}
                  initial={{ opacity: 0, y: 18 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: (i % 3) * 0.04 }}
                  className="group relative overflow-hidden aspect-[5/4] cursor-default bg-navy"
                  data-testid={`industries-page-card-${ind.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                >
                  <img src={ind.image} alt={ind.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-80 group-hover:scale-105 transition-all duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/60 to-transparent" />
                  <div className="relative h-full p-7 flex flex-col justify-between text-white">
                    <div className="w-12 h-12 grid place-items-center border border-white/30 text-gold">
                      <Icon size={20} strokeWidth={1.5} />
                    </div>
                    <div>
                      <h3 className="font-display font-bold text-xl leading-tight">{ind.title}</h3>
                      <div className="mt-3 h-px w-10 bg-gold group-hover:w-20 transition-all duration-500" />
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
